angular.module('bb.appointments').directive('appointmentPaginate', () => {
  return {
    restrict: 'E',
    scope: {
      viewAppointment: '=',
      listingId: '=',
      limit: '=',
      getSort: '<',
    },
    controller: AppointmentPaginateController,
    bindToController: true,
    controllerAs: 'vm',
    template: require('./appointment_paginate.html'),
  };
});

AppointmentPaginateController.$inject = ['appointmentListsService'];
function AppointmentPaginateController(appointmentListsService) {
  const vm = this;

  this.$onInit = function () {
    vm.page = 1;
    vm.currentItems =
      vm.page * vm.limit < vm.totalCount ? vm.page * vm.limit : vm.totalCount;
    vm.sortBy = 'time';
    vm.order = 'DESC';
    if (!vm.getSort) {
      vm.getSort = () => {
        // do nothing
      };
    }
    vm.getSort(vm.sortBy, vm.order);
    // Initial query
    vm.pageChange();
  };

  vm.view = appointment => {
    if (appointment.isHistorical) return;
    vm.viewAppointment(appointment);
  };

  vm.pageClick = function (page) {
    vm.page = page;
    vm.pageChange();
  };

  vm.pageChange = function () {
    vm.appointmentsLoaded = false;
    appointmentListsService
      .getAppointments(
        vm.page,
        vm.limit,
        vm.listingId,
        `${vm.sortBy} ${vm.order}`,
      )
      .then(res => {
        vm.appointments = res.appointments;
        vm.totalCount = res.totalCount;
        vm.currentItems =
          vm.page * vm.limit < vm.totalCount
            ? vm.page * vm.limit
            : vm.totalCount;
        vm.appointmentsLoaded = true;
      });
  };

  vm.sort = sortBy => {
    vm.sortBy = sortBy;
    vm.order = vm.order === 'DESC' ? 'ASC' : 'DESC';
    vm.getSort(vm.sortBy, vm.order);
    vm.page = 1;
    vm.pageChange();
  };
}

export {};
